export default {
  previousVersion: "Versión anterior",
  nextVersion: "Versión siguiente",
  selectVersion: "Selecciona una versión",
  download: "Descargar el documento",
  deleteDocument: "Eliminar el documento"
};
